<span #span class="markdown-inline" [innerHTML]="output"></span>
<!-- {{input}} -->